import React from 'react';
import {getLoginTimeout, getUserManager} from './config/auth.config';

import 'whatwg-fetch';
import { Main } from './Main';
import {AuthProvider} from "./features/auth/AuthContext";
import { reactPlugin } from './AppInsights';
import { AppInsightsContext } from "@microsoft/applicationinsights-react-js";

export const AuthenticatedApp = ()=>{
    let userManager=getUserManager();
    let timeout = getLoginTimeout();
    return (
        <AppInsightsContext.Provider value={reactPlugin}>
            <AuthProvider {...{userManager}} loginTimeout={timeout}
                      onSignIn={([user,url])=>{
                          //window.location.hash=``;
                          if (url){
                              window.location.replace(url);
                          }else{
                              window.history.replaceState("", document.title, window.location.pathname)
                          }
                          
                      }}
            >
                <Main/>
            </AuthProvider>
        </AppInsightsContext.Provider>  
    );
}